import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.css";
import { registerPreventNumberWheel } from "@/utils/preventNumberWheel";
import { registerDropdownBlur } from "@/utils/dropdownBlur";
// Global error handler for unhandled promise rejections
// This helps prevent console errors from browser extensions and cancelled requests
window.addEventListener("unhandledrejection", (event) => {
    // Suppress errors from cancelled requests or browser extension interference
    const error = event.reason;
    if (error?.name === "CanceledError" ||
        error?.code === "ERR_CANCELED" ||
        error?.message?.includes("message channel closed") ||
        error?.message?.includes("asynchronous response")) {
        event.preventDefault();
        return;
    }
    // Log other unhandled rejections for debugging
    console.error("Unhandled promise rejection:", error);
});
registerPreventNumberWheel();
registerDropdownBlur();
ReactDOM.createRoot(document.getElementById("root")).render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
